var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.show,"opacity":"0.6"},scopedSlots:_vm._u([{key:"overlay",fn:function(){return [_c('div',[_c('loading')],1)]},proxy:true}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }